import * as React from "react";
import { createRoot } from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";

import App from "./App";
import { msalInstance } from "./msalConfig";
import "normalize.css/normalize.css";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/select/lib/css/blueprint-select.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import "@blueprintjs/popover2/lib/css/blueprint-popover2.css";
import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";
import "@blueprintjs/datetime2/lib/css/blueprint-datetime2.css";
import "./style.scss";

async function initializeAndRender() {
  try {
    const container = document.getElementById("root") as HTMLElement;
    const root = createRoot(container);
    await msalInstance.initialize();
    await msalInstance.handleRedirectPromise();
    root.render(
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    );
  } catch (e) {
    console.error("MSAL initialization failed", e);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  initializeAndRender();
});
